import React from "react";
import { X, BookMarked } from "lucide-react";

export default function FactCheckPanel({ open, onClose, entries }) {
  if (!open) return null;
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(4,6,10,0.72)",
        backdropFilter: "blur(6px)",
        pointerEvents: "auto",
        padding: 20,
      }}
      data-testid="fact-check-panel"
    >
      <div
        className="hud-panel tab-rise tab-scroll"
        style={{ width: "min(680px, 94vw)", maxHeight: "82vh", overflowY: "auto", borderRadius: 6, padding: "26px 30px" }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 6 }}>
          <BookMarked size={20} color="#c9a24b" />
          <h2 className="font-serif-q" style={{ margin: 0, color: "#e4be65", fontSize: 24 }}>
            Historical Anchor · Fact Check
          </h2>
          <button
            data-testid="fact-check-close-button"
            onClick={onClose}
            className="ghost-btn"
            style={{ marginLeft: "auto", padding: 8, borderRadius: 3, cursor: "pointer" }}
            aria-label="Close"
          >
            <X size={16} />
          </button>
        </div>
        <p style={{ fontSize: 12.5, color: "#9aa0ac", margin: "0 0 20px", lineHeight: 1.5 }}>
          This spatial narrative is grounded in the historical record. Every quote is sourced verbatim from
          Stanley Praimnath's interview and Brian Clark's archival account.
        </p>
        <div style={{ display: "grid", gap: 14 }}>
          {(entries || []).map((e, i) => (
            <div
              key={i}
              style={{ padding: "16px 18px", borderRadius: 4, background: "rgba(26,29,36,0.6)", border: "1px solid rgba(201,162,75,0.18)" }}
            >
              <div className="font-serif-q" style={{ color: "#e4be65", fontSize: 17, marginBottom: 6 }}>
                {e.claim}
              </div>
              <p style={{ margin: "0 0 10px", fontSize: 13, color: "#c2c6cf", lineHeight: 1.55 }}>{e.detail}</p>
              <div className="font-mono-tel" style={{ fontSize: 11, color: "#7e8594", letterSpacing: "0.04em" }}>
                ▸ {e.source}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
